<template>
  <div>
    <button @click="replaceTextLines" style="background-color: #4CAF50; color: white;">文章を変更</button>
    <br>
    <div v-if="firstLine" style="margin-bottom: 10px; font-weight: bold;">
      {{ firstLine }}
      <button @click="copyFirstLine" style="background-color: #2196F3; color: white;">
        {{ copyFirstLineButtonText }}
      </button>
    </div>
    <br>
    <button @click="copyToClipboard" style="background-color: #ff5722; color: white;">
      {{ copyTemplateButtonText }}
    </button>
    <div style="white-space: pre-wrap;">{{ extractedTextHtml }}</div>
  </div>
</template>

<script>
import newText from './PrivacyProtection/newText';

export default {
  data() {
    return {
      termsOfServiceText: `
<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title jpn="特定商取引法に基づく表記" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">運営会社名称</span>
            <span class="text">株式会社はっち</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">代表責任者</span>
            <span class="text">八塚 健</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">会社登記住所・営業所住所</span>
            <span class="text">〒547-0011</span>
            <span class="text">〒547-0011</span>
            <span class="text">大阪府大阪市平野区長吉出戸七丁目3-39</span>

          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">電話番号</span>
            <span class="text">06-6643-9996</span>
            <span class="text">( ※受付時間 : 平日10時-17時 )</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">メールアドレス</span>
            <span class="text">support@xeroplace.jp</span>
            <span class="text">※お問い合わせは、サイト内のチャットよりお願いいたします。原則2営業日以内にはお返事いたします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">価格</span>
            <span class="text">各商品毎に表示</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">商品代金以外の必要料金</span>
            <span class="text">当社の提供するサービスを利用するための機器に関する費用、インターネット接続料金、パケット通信料、消費税、代金支払いの振込手数料</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">引渡時期</span>
            <span class="text">申込受付時</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">販売数量</span>
            <span class="text">特に指定はございません。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">お支払い方法</span>
            <span class="text">クレジットカード・コンビニエンスストア・PayPal・キャリア決済・PayPay・メルペイ・AmazonPayとなります。</span>
            <span class="text">※ご決済後のお客様都合によるキャンセルは承ることができません。予めご容赦ください。</span>
            <span class="text">期限までにお支払いがない場合、自動的にキャンセルとなります。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">支払時期</span>
            <span class="text">クレジットカード：クレジットカード会社の規約に基づく。</span>
            <span class="text">コンビニ決済：ご注文日から３日以内に代金をお支払いください。</span>
            <span class="text">PayPal：PayPalの規約に基づく。</span>
            <span class="text">キャリア決済：各キャリアの規約に基づく。</span>
            <span class="text">PayPay：PayPayの規約に基づく。</span>
            <span class="text">メルペイ：メルペイの規約に基づく。</span>
            <span class="text">Amazonpay：Amazonpayの規約に基づく。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">返品特約と期限</span>
            <span class="text">サービスの性質上、返品・返金はお受けしておりません。</span>
            <span class="text">ただし、弊社に100％過失がある場合はご対応させてただきます。</span>
            <span class="text">以下の場合はご対応いたしかねます。予めご容赦くださいませ。</span>
            <span class="text">配送過程での紛失や損傷等が生じてしまった場合</span>
            <span class="text">BOX等未開封品の動画撮影等が無い場合</span>
            <span class="text">※再シュリンク品の検品は特に留意しておこなわせていただいております。</span>
            <span class="text">商品ご到着後、10日を超えた場合</span>
            <span class="text">PSAなどの鑑定品に傷等が見受けられてしまい、それを理由とした交換・返品依頼を承った場合</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">古物商営業許可</span>
            <span class="text">第431370066203</span>
            <span class="text">株式会社はっち</span>
            <span class="text">埼玉県公安委員会</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>
      `,
      newText,
      extractedTextHtml: [],
      firstLine: '',
      copyFirstLineButtonText: 'firstLineをコピー',
      copyTemplateButtonText: 'templateをコピー',
    };
  },
  mounted() {
    this.replaceTextLines();
  },
  methods: {
    getTextLines() {
      this.extractedTextHtml = this.termsOfServiceText;
      console.log('抽出されたHTML（タグ含む）:', this.extractedTextHtml);
    },
    replaceTextLines() {
      // newTextを改行で分割し、最初の1行を削除する
      const lines = this.newText.split('\n').filter((line) => line.trim() !== '');
      this.firstLine = lines.shift();
      let lineIndex = 0;
      // <Title jpn="ここ" />をfirstLineで置換
      let replacedHtml = this.termsOfServiceText.replace(
        /(<Title jpn=")([^"]*)(" \/>)/,
        (match, openTag, innerText, closeTag) => `${openTag}${this.firstLine}${closeTag}`,
      );

      // spanタグの中身を新しい行で置き換える
      replacedHtml = replacedHtml.replace(
        /(<span class="text">)([\s\S]*?)(<\/span>)/g,
        (match, openTag, innerText, closeTag) => {
          const replacement = lines[lineIndex] ? lines[lineIndex].trim() : innerText;
          lineIndex += 1;
          return `${openTag}${replacement}${closeTag}`;
        },
      );

      this.extractedTextHtml = replacedHtml;
    },
    // 以下、一行目削除しない場合
    replaceTextLinesWithoutRemovingFirstLine() {
      const lines = this.newText.split('\n').filter((line) => line.trim() !== '');
      let lineIndex = 0;

      this.extractedTextHtml = this.termsOfServiceText.replace(
        /(<span class="text">)([\s\S]*?)(<\/span>)/g,
        (match, openTag, innerText, closeTag) => {
          const replacement = lines[lineIndex] ? lines[lineIndex].trim() : innerText;
          lineIndex += 1;
          return `${openTag}${replacement}${closeTag}`;
        },
      );
    },
    copyToClipboard() {
      const trimmedText = this.extractedTextHtml.trim();
      navigator.clipboard.writeText(trimmedText)
        .then(() => {
          this.copyTemplateButtonText = 'コピーしました！';
          setTimeout(() => { this.copyTemplateButtonText = 'templateをコピー'; }, 2000);
        })
        .catch((error) => {
          console.error('コピーに失敗しました:', error);
        });
    },
    copyFirstLine() {
      navigator.clipboard.writeText(this.firstLine)
        .then(() => {
          this.copyFirstLineButtonText = 'コピーしました！';
          setTimeout(() => { this.copyFirstLineButtonText = 'firstLineをコピー'; }, 2000);
        })
        .catch((error) => {
          console.error('コピーに失敗しました:', error);
        });
    },
  },
};
</script>
